import {
    GET_SPLUNK_REFRESH,
    GET_SPLUNK_REFRESH_SUCCESS,
    GET_SPLUNK_REFRESH_FAIL,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_SUCCESS,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_FAIL,
    GET_SPLUNK_ALL_RESOURCE_COUNT,
    GET_SPLUNK_ALL_RESOURCE_COUNT_SUCCESS,
    GET_SPLUNK_ALL_RESOURCE_COUNT_FAIL,
    GET_USER_RESCAN_STATUS_SPLUNK,
    GET_USER_RESCAN_STATUS_SPLUNK_SUCCESS,
    GET_USER_RESCAN_STATUS_SPLUNK_FAIL,
    POST_SPLUNK_SERVICE_MAPPING,
    POST_SPLUNK_SERVICE_MAPPING_SUCCESS,
    POST_SPLUNK_SERVICE_MAPPING_FAIL,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL,
    GET_SPLUNK_ALERTS,
    GET_SPLUNK_ALERTS_SUCCESS,
    GET_SPLUNK_ALERTS_FAIL,
    GET_SPLUNK_DEFAULT_THRESHOLD,
    GET_SPLUNK_DEFAULT_THRESHOLD_SUCCESS,
    GET_SPLUNK_DEFAULT_THRESHOLD_FAIL,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_RESOURCE_BY_ID,
    GET_SPLUNK_RESOURCE_BY_ID_SUCCESS,
    GET_SPLUNK_RESOURCE_BY_ID_FAIL,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
    GET_SPLUNK_RESOURCES,
    GET_SPLUNK_RESOURCES_SUCCESS,
    GET_SPLUNK_RESOURCES_FAIL,
    PUT_SPLUNK_THRESHOLD,
    PUT_SPLUNK_THRESHOLD_SUCCESS,
    PUT_SPLUNK_THRESHOLD_FAIL,
    POST_SPLUNK_DISABLE_ALERTS,
    POST_SPLUNK_DISABLE_ALERTS_SUCCESS,
    POST_SPLUNK_DISABLE_ALERTS_FAIL,
    POST_SPLUNK_ENABLE_ALERTS,
    POST_SPLUNK_ENABLE_ALERTS_SUCCESS,
    POST_SPLUNK_ENABLE_ALERTS_FAIL,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS_FAIL,
    PUT_SPLUNK_ALERTS,
    PUT_SPLUNK_ALERTS_SUCCESS,
    PUT_SPLUNK_ALERTS_FAIL
} from "./actionTypes";

const INIT_STATE = {
    resource_dynamic_alerts_deployed: [],
    resource_missing_dynamic_alerts: [],
    default_threshold_splunk_resource: [],
    splunk_resource: {},
    splunk_resource_missing_alerts: [],
    splunk_default_thresholds: [],
    splunk_alerts: [],
    splunk_all_resource_count: {},
    orgSplunkResourceTypes: [],
    all_resource_alerts: {},
    error: {},
    refresh: {},
    splunk_rescan_status: true,
    splunk_dynamic_default_thresholds: [],
    splunk_resources: [],
    put_splunk_threshold: {},
    create_resource_alerts: {},
    put_splunk_alerts: {}
}

const Splunk = (state = INIT_STATE, action) => {
    switch(action.type){

        case GET_SPLUNK_REFRESH:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_REFRESH_SUCCESS:
            return {
                ...state,
                refresh: action.payload
            };

        case GET_SPLUNK_REFRESH_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_SUCCESS:
            return {
                ...state,
                all_resource_alerts: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_ALL_ORG_SPLUNK_RESOURCE_TYPES:
            return {
                ...state,
                error: action.payload
            };

        case GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_SUCCESS:
            return {
                ...state,
                orgSplunkResourceTypes: action.payload
            };

        case GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_COUNT:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_COUNT_SUCCESS:
            return {
                ...state,
                splunk_all_resource_count: action.payload
            };

        case GET_SPLUNK_ALL_RESOURCE_COUNT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_USER_RESCAN_STATUS_SPLUNK:
            return {
                ...state,
                error: action.payload
            };

        case GET_USER_RESCAN_STATUS_SPLUNK_SUCCESS:
            return {
                ...state,
                splunk_rescan_status: action.payload.scan_completed
            };

        case GET_USER_RESCAN_STATUS_SPLUNK_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_SERVICE_MAPPING:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_SERVICE_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.all_resource_alerts[item.id].application_service_id = item.application_service_id;
                state.all_resource_alerts[item.id].environment = item.environment;
                state.all_resource_alerts[item.id].deployment_stage = item.deployment_stage;
            });
            return {
                ...state,
                all_resource_alerts: state.all_resource_alerts,
            }

        case POST_SPLUNK_SERVICE_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.all_resource_alerts[item.id].opsgenie_team_id = item.opsgenie_team_id;
                state.all_resource_alerts[item.id].environment = item.environment;
                state.all_resource_alerts[item.id].deployment_stage = item.deployment_stage;
            });
            return {
                ...state,
                all_resource_alerts: state.all_resource_alerts,
            }

        case POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.all_resource_alerts[item.id].pagerduty_service_id = item.pagerduty_service_id;
                state.all_resource_alerts[item.id].environment = item.environment;
                state.all_resource_alerts[item.id].deployment_stage = item.deployment_stage;
            });
            return {
                ...state,
                all_resource_alerts: state.all_resource_alerts,
            }

        case POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS:
            return {
                ...state,
                all_resource_alerts: action.payload
            };

        case GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS:
            return {
                ...state,
                splunk_all_resource_count: action.payload
            };

        case GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALERTS:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_ALERTS_SUCCESS:
            return {
                ...state,
                splunk_alerts: action.payload
            };

        case GET_SPLUNK_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD_SUCCESS:
            return {
                ...state,
                splunk_default_thresholds: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                splunk_resource_missing_alerts: action.payload
            };

        case GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_RESOURCE_BY_ID:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_RESOURCE_BY_ID_SUCCESS:
            return {
                ...state,
                splunk_resource: action.payload
            };

        case GET_SPLUNK_RESOURCE_BY_ID_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                default_threshold_splunk_resource: action.payload
            };

        case GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                resource_dynamic_alerts_deployed: action.payload
            };

        case GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                resource_missing_dynamic_alerts: action.payload
            };

        case GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS:
            return {
                ...state,
                splunk_dynamic_default_thresholds: action.payload
            };

        case GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_RESOURCES:
            return {
                ...state,
                error: action.payload
            };

        case GET_SPLUNK_RESOURCES_SUCCESS:
            return {
                ...state,
                splunk_resources: action.payload
            };

        case GET_SPLUNK_RESOURCES_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case PUT_SPLUNK_THRESHOLD:
            return {
                ...state,
                error: action.payload
            };

        case PUT_SPLUNK_THRESHOLD_SUCCESS:
            return {
                ...state,
                put_splunk_threshold: action.payload
            };

        case PUT_SPLUNK_THRESHOLD_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_DISABLE_ALERTS:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_DISABLE_ALERTS_SUCCESS:
            return {
                ...state,
                splunk_alerts: action.payload
            };

        case POST_SPLUNK_DISABLE_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_ENABLE_ALERTS:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_ENABLE_ALERTS_SUCCESS:
            return {
                ...state,
                splunk_alerts: action.payload
            };

        case POST_SPLUNK_ENABLE_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_CREATE_RESOURCE_ALERTS:
            return {
                ...state,
                error: action.payload
            };

        case POST_SPLUNK_CREATE_RESOURCE_ALERTS_SUCCESS:
            return {
                ...state,
                create_resource_alerts: action.payload
            };

        case POST_SPLUNK_CREATE_RESOURCE_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case PUT_SPLUNK_ALERTS:
            return {
                ...state,
                error: action.payload
            };

        case PUT_SPLUNK_ALERTS_SUCCESS:
            return {
                ...state,
                put_splunk_alerts: action.payload
            };

        case PUT_SPLUNK_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
}

export default Splunk;